import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { deleteDocument, getDocuments } from "../../actions/documentsActions"
import { useLocation, useNavigate } from "react-router"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import Loader from "../../components/loaders/Loader"
import Swal from "sweetalert2"

export default function Documents() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const { documents, document, resultdocument, loading } = useSelector(state => state.documents)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    useEffect(() => {
        if (clientauth) {
            dispatch(getDocuments(page, limit, search))
        }
    }, [dispatch, t, clientauth, location, page, limit, search])

    const handleDelete = (id) => {
        Swal.fire({
            title: t('manager.documents.deleteDocumentQuestion'),
            showDenyButton: true,
            confirmButtonText: t('global.ok'),
            denyButtonText: t('global.cancel'),
            icon: 'warning'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteDocument(id))
            }
        })
    }

    useEffect(() => {
        if (resultdocument) {
            let resultnow = resultdocument
            dispatch({ type: 'DOCUMENT_RESET_RESULT' })
            switch (resultnow) {
                case 'documentCreated':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('manager.documents.createsuccess')
                    })
                    break
                case 'documentUpdated':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('manager.documents.editsuccess')
                    })
                    break
                case 'documentDeleted':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('manager.documents.deletesuccess')
                    })
                    break
                default:
                    break
            }
        }
    }, [resultdocument, dispatch, t])

    return (
        <Container className='contenido p-5'>
            <Row>
                <Col xs={8} className='text-center'>
                    <h1>{t('manager.documents.documentmanagement')}</h1>
                    <h4>{t('manager.documents.documentmanagementdescription')}</h4>
                </Col>
                <Col xs={4} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => navigate('create')}>
                        + {t('manager.documents.createdocument')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex my-2">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder={t("datatables.buscar")}
                            value={searchAux || ""}
                            onChange={e => {
                                setSearchAux(e.target.value);
                                setPage(1);
                            }}
                            onKeyDown={(e) => { if (e.key === 'Enter') { setSearch(searchAux); setPage(1); } }}
                        />
                        <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                    </div>
                    {loading ? (
                        <Loader />
                    ) : (
                        <Row className='g-3'>
                            {documents && documents.map(document => (
                                <Col key={document._id} xs={12}>
                                    <Card>
                                        <Card.Body>
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <Card.Title>{document.title}</Card.Title>
                                                    <Card.Subtitle className="mb-2 text-muted">{t('manager.documents.category')}: {document.category}</Card.Subtitle>
                                                    <Card.Text>{t('manager.documents.author')}: {document.author}</Card.Text>
                                                    <Card.Text className="text-muted small">
                                                        {t('manager.documents.createdAt')}: {new Date(document.createdAt).toLocaleDateString()} | {t('manager.documents.updatedAt')}: {new Date(document.updatedAt).toLocaleDateString()}
                                                    </Card.Text>
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <i
                                                        className='fas fa-edit'
                                                        style={{ cursor: 'pointer', color: 'black', fontSize: '1.2rem' }}
                                                        onClick={() => navigate('edit/' + document._id)}
                                                    />
                                                    <i
                                                        className='fas fa-trash'
                                                        style={{ cursor: 'pointer', color: 'red', fontSize: '1.2rem' }}
                                                        onClick={() => handleDelete(document._id)}
                                                    />
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                </Col>
            </Row>
        </Container>
    )
}